import axios from 'axios';
import {DateTime} from 'luxon';

export default {
   data() {
      return {
         dialog_show_error: false,
         show_error_obj: null,

      };
   },

   watch: {
      show_error_obj(newVal, oldVal){
         if ( newVal !== null){

            this.dialog_show_error = true;
         }

      },

      dialog_show_error(newVal, oldVal){
         if (newVal === false && oldVal === true){
            this.show_error_obj = null;
         }
      }
   },

   methods: {

      /**
       * Intended to be used an
       * @param error - error object,
       *
       * @returns
       */
      show_error_details(error, info=''){

         let error2 = {};

         try{
            let msg = error.message;
            if (error.response !== undefined){
               if (error.response.data !== undefined){
                  if (error.response.data.message !== undefined){
                     msg = error.response.data.message;
                  }
                  else{
                     msg = error.response.data;
                  }
               }
            }

            let keys = Object.getOwnPropertyNames(error);
            keys.forEach(x => {
               error2[x] = error[x];
            });

            this.show_error_obj = {
               URL: window.location.href,
               CONTEXT_INFO: info,
               ERROR: error2,
               // USER: this.$auth.profile,
               USER: {},
               msg: msg,
            };

            console.error('Error Message: ', msg);
            console.error('Full Error Object: ', error2 );

            return 'An error occurred: ' + msg;
         }
         catch (e) {
            console.error('Had an error while trying to process another error.');
            console.log('Original Error: ', error2.message);
            console.log('Second Error: ', e);
         }
      },

      /**
       * Simple helper function to get index of an object in an array based on a given property
       *
       * @param array - an array of objects
       * @param attr - str, name of proprty to search for
       * @param value - value to search for

       * @returns index of item or -1 if not found
       *
       * ref: https://stackoverflow.com/questions/7176908/how-to-get-index-of-object-by-its-property-in-javascript/54015295
       */

      findWithAttr(array, attr, value) {

         // console.log('array', array)
         for(let i = 0; i < array.length; i += 1) {
            let a = attr.split('.');
            let val;
            val = array[i][a[0]];


            // console.log('a', a)
            for (let j=1; j < a.length; j++) {

               val = val[a[j]];
            }

            // console.log('val', val, 'value', value)
            if(val === value) {
               return i;
            }
         }
         return -1;
      },


      sort_bib_list(list) {

         for (let i = 0; i < list.length; i++) {

            if (list[i].raw !== '' && list[i].raw != null) {
               list[i].sort_ix = list[i].raw;

            } else if (list[i].title !== '' && list[i].title != null) {
               list[i].sort_ix = list[i].title;

            } else if (list[i].url !== '' && list[i].url != null) {
               list[i].sort_ix = list[i].url;
            }
         }


         list.sort((a, b) => (a.sort_ix > b.sort_ix) ? 1 : -1);
         return list;

      },










      /**
       * Converts various date formats to a luxon DataTime
       * @param date
       */
      get_luxon_dt(date){
         //https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date

         let d; //datetime object


         if (typeof date === 'string'){
            // let s = date.slice(0, 10).split('-');
            // date = Date.UTC(s[0], s[1], s[2]);
            // date = new Date(date);

            d = DateTime.fromISO(date);
            //TODO: need to handle error if date is not a properly fmt'd srr
         }


         else if (Object.prototype.toString.call(date) === '[object Date]'){
            // is a native Date object

            // d = date.toIsoString();
            d = DateTime.fromJSDate(date);

         }

         else if (date instanceof DateTime){
            d = date;
         }

         return d;
      },


      /**
       *
       * @param date     : str | js date obj | luxon DateTime instance
       * @param zone     : str, the timezone
       * @param dateOnly : bool, if true then strips time off.
       */
      iso_date(date,dateOnly=false){
         // console.log('d', date, d)

         let d = this.get_luxon_dt(date);

         if (dateOnly)
            return d.toISODate();
         else{
            return d.toISO();
         }
      },



      /**
       * Returns the last day of the month
       *
       * NOTES: this fn doesn't not handle time or timezone properly.
       * Assumes that the date is in the timezone of interest and simply truncates the time info.
       *
       * @param date - an iso fmt date str, note only the first 10 chars are used
       *
       * returns str formatted as yyyy-mm-dd
       *
       * ref: https://stackoverflow.com/questions/222309/calculate-last-day-of-month-in-javascript
       */
      get_eom(date){

         if (typeof date === 'string'){
            let s = date.slice(0, 10).split('-');
            date = Date.UTC(s[0], s[1], s[2]);
            date = new Date(date);
            //TODO: need to handle error if date is not a properly fmt'd srr
         }
         else{
            throw Error('date must be an iso string');
         }


         //note Date uses 0...11 for months
         let month = date.getMonth();
         let year = date.getFullYear();

         if (month < 11){
            month += 1;
         }
         else {
            month = 0;
            year += 1;
         }

         let tmp = Date.UTC(year, month, 1 );
         tmp = new Date(tmp - 1);

         // console.log(date, tmp)

         return tmp.toISOString().slice(0, 10);


      },




      /**
       * rounds
       * @param value     - value to round
       * @param precision - num of digits to round to
       * @returns {number}
       * Taken from: https://stackoverflow.com/questions/7342957/how-do-you-round-to-1-decimal-place-in-javascript
       */
      round(value, precision) {
         let multiplier = Math.pow(10, precision || 0);
         return Math.round(value * multiplier) / multiplier;
      },


      /**
       *
       * @param x : array of numbers
       */
      sum(x){
         return x.reduce( (total, n) => {return total + n} );
      },

      avg(x){
         return x.reduce( (total, n) => {return total + n} ) / x.length;
      },

      /**
       * helper fn to format numbers into dollars string
       * @param val    - number
       * @param places - number, the decimals to return, default 0
       * @returns {*}
       * @private
       */
      fmt_money(val, places=0, prefix='$'){
         let val2=val;
         try{

            if (typeof val === 'string'){
               val2 = parseFloat(val);
            }

            return prefix+ val2.toFixed(places).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
         }catch (e) {
            console.log(e)
            return val;
         }
      },//_fmt_money()

      fmt_month(d){
         let d2 =DateTime.fromISO(d);
         return d2.toLocaleString({month: 'long', year: 'numeric'});
      },

      fmt_date(d){
         if (d == null || d === ''){
            return '';
         }

         // console.log('d', d)
         let d2 =DateTime.fromISO(d);
         return d2.toLocaleString(DateTime.DATE_SHORT); //{month: 'long', year: 'numeric', 'day': '2-digit'})
      },

      fmt_datetime(d){
         if (d == null || d === '')   return '';

         let d2 =DateTime.fromISO(d);
         return d2.toLocaleString(DateTime.DATETIME_SHORT); //{month: 'long', year: 'numeric', 'day': '2-digit'})
      },

      fmt_date_diff(d1, d2){
         let t1 =DateTime.fromISO(d1);
         let t2 =DateTime.fromISO(d2);

         let ans = t1.diff(t2).toFormat('d:hh:mm:ss');

         // console.log(ans)
         if (ans === 'Invalid Duration')
            return '';
         return ans;

      },


      /**
       * formats time into appropriate unit, mins, days, etc.
       * @param t : float, an amount of time
       * @param unit : unit of t, e.g. hours
       * @returns {string}
       */
      fmt_time_diff(t, unit='hours'){

         if (unit !== 'hours')
            throw Error('unit not implemented yet')

         let prefix = '';
         if (t<0){
            prefix = '-';
            t = -t;
         }

         let u = 'h';
         let ans;

         if (Math.abs(t) < 0.0001)
            return '0';

         if (t < 1){
            ans = t*60; // convert to minutes
            u = 'mins'
         }

         //time less than a day
         else if (t>=1 && t < 24){
            ans = t; // leave as hours
            u = 'hours'
         }

         //time between a day and 60 days
         else if (t>=24 && t < 24*60){
            ans = t/24; // convert to days
            u = 'days'
         }

         //time between a day and 60 days
         else {
            ans = t/24/30; // convert to months
            u = 'months'
         }

         return prefix + this.round(ans, 1).toString() + ' ' + u;


      },

      fmt_dateAndTime(d, t){
         let d2 =DateTime.fromISO(d+'T'+t);
         return d2.toLocaleString(DateTime.DATETIME_SHORT); //{month: 'long', year: 'numeric', 'day': '2-digit'})
      },


      fmt_trim_str(s, len=10){

         if (s == null)
            return s;

         if (s.length <= len)
            return s;
         else{
            return s.slice(0, len) + '...';
         }

      },


      /**
       * parses a date str in mm/dd/yyyy fmt and returns it in yyy-mm-dd
       * @param date
       * @returns {*}
       */
      parseDateStr (date) {
         if (!date) return null;

         const [month, day, year] = date.split('/')
         return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },


   }, // methods

}; // export


